// The app's icons: lucide (lucide-react), under the names the screens already
// use. Decorative only: every icon is aria-hidden, so no accessible name or
// test query changes because an icon was added beside it.

import type { ReactNode } from 'react';
import {
  Activity,
  ArrowLeftRight,
  ArrowRight,
  BookOpen,
  Building2,
  CalendarDays,
  Camera,
  Check,
  ChevronDown,
  CircleCheck,
  CirclePercent,
  Clock,
  Euro,
  Eye,
  FileCheck,
  FileText,
  House,
  MessageSquare,
  Ellipsis,
  Plus,
  SquareCheckBig,
  Inbox,
  Info,
  Landmark,
  Languages,
  LayoutGrid,
  ListTodo,
  Lock,
  Mail,
  Plug,
  RefreshCw,
  Route,
  Search,
  Send,
  ShieldCheck,
  SlidersHorizontal,
  Sparkles,
  Target,
  Timer,
  TriangleAlert,
  Upload,
  User,
  Users,
  Wallet,
  X,
  Zap,
  type LucideIcon,
} from 'lucide-react';

const ICONS = {
  grid: LayoutGrid,
  list: ListTodo,
  building: Building2,
  file: FileText,
  swap: ArrowLeftRight,
  mail: Mail,
  sliders: SlidersHorizontal,
  plug: Plug,
  activity: Activity,
  sparkle: Sparkles,
  check: Check,
  clock: Clock,
  shield: ShieldCheck,
  send: Send,
  user: User,
  chev: ChevronDown,
  euro: Euro,
  bank: Landmark,
  target: Target,
  arrow: ArrowRight,
  upload: Upload,
  eye: Eye,
  alert: TriangleAlert,
  lock: Lock,
  camera: Camera,
  bolt: Zap,
  refresh: RefreshCw,
  search: Search,
  info: Info,
  calendar: CalendarDays,
  timer: Timer,
  inbox: Inbox,
  done: CircleCheck,
  percent: CirclePercent,
  route: Route,
  users: Users,
  ledger: BookOpen,
  wallet: Wallet,
  language: Languages,
  close: X,
  brand: FileCheck,
  review: SquareCheckBig,
  chat: MessageSquare,
  home: House,
  more: Ellipsis,
  plus: Plus,
} as const satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

export function Icon({ name, size = 16 }: { readonly name: IconName; readonly size?: number }): ReactNode {
  const Glyph = ICONS[name];
  return <Glyph className="i" size={size} strokeWidth={1.9} aria-hidden="true" focusable="false" />;
}
